import React from 'react';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import {
  Button,
  IconButton,
  Stack,
  Typography,
  styled,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { backHomeLink } from 'utils/constants';

const StyledIconButton = styled(IconButton)({
  padding: 5,
});

const RegisterSection = ({ onClose, isSmDown, locale, ctx }) => {
  // Hooks
  const intl = useIntl();
  const i18n = translations.ExhibitorsV2(intl).Register;
  const theme = useTheme();
  const LOGIN_URL = `${backHomeLink}/${locale}/saml_login?lang=${locale}`;

  // Functions
  const handleOverflowBody = () => {
    const bodyStatus = document.body.getAttribute('style');
    if (bodyStatus.includes('overflow: hidden')) {
      document.body.style.overflow = 'visible';
      document.body.style.paddingTop = 79;
    }
  };

  const handleClose = () => {
    handleOverflowBody();
    onClose && onClose();
  };

  return (
    <div>
      <div
        tabIndex={0}
        role="button"
        onClick={handleClose}
        style={{
          position: 'absolute',
          top: 12,
          right: 24,
        }}
      >
        <StyledIconButton>
          <CloseIcon fontSize={isSmDown ? 'large' : 'small'} />
        </StyledIconButton>
      </div>
      <Stack gap={'25px'}>
        <div>
          <Typography
            variant={'m-bold'}
            textAlign={'center'}
            style={{ fontFamily: 'Suisse-Intl' }}
            paragraph
          >
            {ctx === 'visit' ? i18n.titleVisit : i18n.title}
          </Typography>
          <Typography variant={'body2'} textAlign={'center'}>
            {ctx === 'visit' ? i18n.subtitle : i18n.subtitleCalendar}
          </Typography>
        </div>
        <Stack alignItems={'center'}>
          <Button
            autoFocus
            style={{
              ...(!isSmDown && {
                width: 125,
                height: 44,
              }),
              ...(isSmDown && {
                width: '100%',
                height: '44px',
              }),
            }}
            onClick={() => (window.location.href = LOGIN_URL)}
            variant={'contained'}
            color="primary"
          >
            {i18n.login}
          </Button>
        </Stack>
        <Typography variant={'body2'} textAlign={'center'}>
          {i18n.notAccount}{' '}
          <span
            style={{
              cursor: 'pointer',
              color: theme.palette.primary.main,
              textDecoration: 'underline',
            }}
            onClick={() => (window.location.href = LOGIN_URL)}
          >
            {i18n.registerNow}
          </span>
        </Typography>
      </Stack>
    </div>
  );
};

export { RegisterSection };
